import { FC } from 'react';

// import Chip from '@/components/Chip';
import AgentLatency from './AgentLatency';
import { TAgentMarketplaceProject } from './types';

type TProps = {
  agent: TAgentMarketplaceProject;
};

export const AgentMarketplaceHeroCard: FC<TProps> = ({ agent }) => {
  return (
    <div className="h-[285px] cursor-pointer overflow-hidden rounded-[20px] border-[3px] border-purple bg-primary p-9 hover:bg-secondary">
      <div className="flex flex-col gap-2">
        <div className="text-lg font-semibold text-secondary">
          {agent.display_name}
        </div>
        <div className="line-clamp-5 text-sm text-secondary">
          {agent.description}
        </div>
        <div className="flex flex-row items-center gap-1 overflow-hidden text-ellipsis whitespace-pre">
          <span className="text-sm text-secondary">By</span>
          <span className="text-sm font-semibold text-secondary">
            {agent.organization_display_name}
          </span>
        </div>
        <AgentLatency agent={agent} />
      </div>
    </div>
  );
};

export default AgentMarketplaceHeroCard;
